import {Component, OnDestroy, ViewChild} from '@angular/core';
import {Store} from '@ngrx/store';
import {Subject, takeUntil} from 'rxjs';
import {FetchMetricOptionListRequest} from '../../../core/clients-list.actions';
import {metricOptionList} from '../../../core/clients-list.selectors';
import * as fromRoot from '../../../../../../state/app.state';
import {CommonService} from '../../../../../shared/services/common.service';
import {
  AddMetricOptionComponent
} from '../../add-metric-option/add-metric-option.component';
import {
  EditMetricOptionComponent
} from '../../edit-metric-option/edit-metric-option.component';
import {ClientListService} from '../../../services/client-list.service';
import {MetricOptionModel} from '../../../../../../models/metric-option.model';
import {
  MetricOptionListModel
} from '../../../../../../models/metric-option-list.model';
import {MatSort, Sort} from "@angular/material/sort";
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {
  indicatorColors, measurementStatusColors,
  roles,
  roleUrlMap,
  sortOrderMap
} from '../../../../../shared/constants/common.constants';

@Component({
  selector: 'app-measurement-information-table',
  templateUrl: './measurement-information-table.component.html',
  styleUrls: ['./measurement-information-table.component.css']
})
export class MeasurementInformationTableComponent implements OnDestroy {
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild(MatSort) sort: MatSort;

  loading: boolean = false;
  metricOptionListDetails: MetricOptionListModel;
  tableData: any[];
  dataSource: any = new MatTableDataSource();
  displayedColumns = [
    'name',
    'isActive',
    'createdAt',
    'activeGroupCount',
  ];

  role: number;
  roles = roles;
  userRole: number;
  sortColumn: any;
  sortOrder: any;

  isFirstPage = true;
  nonEditableCode: any[] = ["weight", 'height', 'bp']

  selectedUserId: number | null;
  selectedUserRole: number | null;
  statusLabelMap = {
    1: 'Active',
    2: 'Inactive',
  }
  protected readonly roleUrlMap = roleUrlMap;
  private readonly OnDestroy: Subject<any> = new Subject<any>();
  private metricOptionListFilters: { isActive?: boolean } = null;

  constructor(
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private clientListService: ClientListService,
  ) {

    // fetch metric options list
    this.fetchMetricOptionList();

    this.store.select(metricOptionList)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.loading = data.loading;
        this.metricOptionListDetails = data;

        if (!data.loading) {
          this.dataSource.data = [...data.list];


          if (data.hasNext) {
            setTimeout(() => {
              if (this.sortColumn && data.pageNumber === 1) {
                this.commonService.scrollColumnInView(this.sortColumn);
              }
            }, 0)

            setTimeout(() => {
              // check window height for infinite scroll
              this.commonService.checkInfiniteScrollHeightAndCallNext('table-wrapper', () => {
                this.onScroll();
              });
            }, 0)
          }
        }
      });

    // listen for add metric button click from parent
    this.clientListService.onAddMeasurementClick.pipe(takeUntil(this.OnDestroy))
      .subscribe(() => {
        this.handleAddMetricOption();
      });

    // listen for filter changes from the filter component
    this.clientListService.onMeasurementFilterChange.pipe(takeUntil(this.OnDestroy))
      .subscribe((filters) => {
        this.metricOptionListFilters = filters;
        this.isFirstPage = true;
        this.fetchMetricOptionList();
      })

  }

  fetchMetricOptionList(pageNumber = 1, limit = 10) {

    this.store.dispatch(FetchMetricOptionListRequest({
      payload: {
        ...this.metricOptionListFilters,
        pageNumber,
        limit,
        ...(this.sortOrder ? {sortOrder: this.sortOrder} : {}),
        ...(this.sortOrder ? {sortColumn: this.sortColumn} : {}),
      }
    }));
  }


  handleAddMetricOption() {
    // open add dialog
    this.commonService.openDialog({
      data: {
        component: AddMetricOptionComponent,
        panelWidth: 20,
        extras: {
          ...this.metricOptionListFilters,
          pageNumber: 1,
          limit: 10,
        },
      }
    })
  }

  handleEditMetricOption(metricOption: MetricOptionModel) {
    // open edit dialog
    this.commonService.openDialog({
      data: {
        component: EditMetricOptionComponent,
        panelWidth: 20,
        metricOption,
        extras: {
          ...this.metricOptionListFilters,
          pageNumber: 1,
          limit: 10,
        },
      }
    })
  }

  onScroll() {
    if (this.metricOptionListDetails?.hasNext && !this.metricOptionListDetails?.loading) {
      this.fetchMetricOptionList(this.metricOptionListDetails.pageNumber + 1, this.metricOptionListDetails.limit);
      this.isFirstPage = false;
    }
  }

  sortData(sort: Sort) {
    this.isFirstPage = true;
    this.sortColumn = `${sort.active}`;
    this.sortOrder = sortOrderMap[sort.direction];

    this.fetchMetricOptionList();
  }


  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }

  protected readonly measurementStatusColors = measurementStatusColors;
}
